export default {
  inject: ['load'],
  data() {
    return {};
  },
  methods: {
    getPatientDrugHistoryByIdFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getPatientDrugHistoryById', id).then(() => {
        if (this.$store.state.patientDrugHistoryModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          let temp = this.$store.state.patientDrugHistoryModule.patientDrugHistory;
          if (this.$route.name == 'followUpPatiant') {
            if (temp) {
              this.setData(temp);
            }
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.patientDrugHistoryModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.patientDrugHistoryModule.successFlag) {
                this.getPatientDrugHistoryByIdFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getAllPatientDrugHistoryFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllPatientDrugHistory', id).then(() => {
        if (this.$store.state.patientDrugHistoryModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          let temp = this.$store.state.patientDrugHistoryModule.allPatientDrugHistory;
          if (this.$route.name == 'followUpPatiant') {
            if (temp) {
              this.setData(temp);
            }
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.patientDrugHistoryModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.patientDrugHistoryModule.successFlag) {
                this.getAllPatientDrugHistoryFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    addPatientDrugHistoryFunction: function (data) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('addPatientDrugHistory', data).then(() => {
        if (this.$store.state.patientDrugHistoryModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$route.name == 'followUpPatiant') {
            this.getAllPatientDrugHistoryFunction(this.patientId);
            this.patientDrugHistoryTrumaTypeAdded();
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.patientDrugHistoryModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.patientDrugHistoryModule.successFlag) {
                this.addPatientDrugHistoryFunction(data);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    deletePatientDrugHistoryFunction: function (data) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('deletePatientDrugHistory', data.id).then(() => {
        if (this.$store.state.patientDrugHistoryModule.successFlag) {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$route.name == 'followUpPatiant') {
            this.removeItem(data.title);
            this.getAllPatientDrugHistoryFunction(this.patientId);
          }
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.patientDrugHistoryModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.deletePatientDrugHistoryFunction(data);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.patientDrugHistoryModule.error;
      if (this.$refs.snackRef) {
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
      } else {
        this.showErrorAlert(this.snackText);
      }
    },
  },
};
